module.exports = __webpack_public_path__ + "static/img/oa@3x.2e9d5926.png";